import {
  PROFILE_LOADING,
  PROFILE_END_LOADING,
  PROFILE_GET_DATA,
} from "../redux/types";

import * as api from "./api";

export const getClientProfile =
  (callbackFN = null) =>
  async (dispatch) => {
    const response = await api.get(dispatch, {
      url: "/clients/currentprofile",
      loadingType: PROFILE_LOADING,
      successType: PROFILE_GET_DATA,
      errorType: PROFILE_END_LOADING,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

export const updateClientProfile =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/clients/updatecurrent",
      loadingType: PROFILE_LOADING,
      successType: PROFILE_GET_DATA,
      errorType: PROFILE_END_LOADING,
      data,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

export const updateCurrentPassword =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/clients/updatecurrent_password",
      loadingType: PROFILE_LOADING,
      successType: PROFILE_END_LOADING,
      errorType: PROFILE_END_LOADING,
      delay: 500,
      data,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };
